import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { FieldMapValue, PreVisitContactData, PreVisitContactType } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const contactTypeLabel: Record<PreVisitContactType, string> = {
  'phone-call': 'Phone call',
  'video-call': 'Video call',
  'in-person-only': 'In-person only',
}

const contactTypeBadgeScheme: Record<PreVisitContactType, string> = {
  'phone-call': 'blue',
  'video-call': 'purple',
  'in-person-only': 'gray',
}

export const PreVisitContactView = ({ data }: { data: FieldMapValue }) => {
  const contact = data.preVisitContact as PreVisitContactData | undefined
  if (!contact?.contactType) return null

  return (
    <Box>
      <SectionLabel>Pre-Visit Contact</SectionLabel>
      <Flex gap={3} align="center" flexWrap="wrap">
        <Badge colorScheme={contactTypeBadgeScheme[contact.contactType]} fontSize="xs">
          {contactTypeLabel[contact.contactType]}
        </Badge>
        {contact.contactMinutes != null && (
          <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.200' }}>
            {contact.contactMinutes} min
          </Text>
        )}
      </Flex>
      {contact.contactNote && (
        <Text fontSize="sm" color="gray.600" _dark={{ color: 'gray.300' }} mt={1}>
          {contact.contactNote}
        </Text>
      )}
    </Box>
  )
}
